import Icon from '../../../components/AppIcon';

const QuestionCard = ({ icon, title, description, children, isActive = true }) => {
  return (
    <div className="bg-white rounded-xl p-4 md:p-6 lg:p-8 shadow-sm border border-slate-100 w-full">
      <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/5 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name={icon} size={20} className="md:w-6 md:h-6" color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-xl md:text-2xl font-semibold text-slate-900 mb-1 md:mb-2 leading-tight">
            {title}
          </h3>
          {description && (
            <p className="text-sm md:text-base text-slate-600 leading-relaxed">
              {description}
            </p>
          )}
        </div>
      </div>
      <div className="space-y-2 md:space-y-3">
        {children}
      </div>
    </div>
  );
};

export default QuestionCard;